export const documentLayouts = ["twoColumn", "oneColumn"] as const;
export type DocumentLayout = typeof documentLayouts[number];

export const documentLayoutNames: Record<DocumentLayout, string> = {
  twoColumn: "Two Columns",
  oneColumn: "One Column",
};
